// @export const
export const REDIRECT = 'REDIRECT'
// @end

// @declare interfaces
export interface IActionState{
  redirect: boolean
  url_logout:string
}
// @end

// @declare actions
interface IRedirectAction{
  type: typeof REDIRECT
  payload:IActionState
}
// @end

// @export interfaces
export type RedirectActionTypes = IRedirectAction
// @end
